module.exports = __webpack_public_path__ + "img/permata.46a1337a.png";